import type {
  Team,
  TeamMineResponse,
  TeamUpdateRequest,
  TeamWriteRequest,
} from "@repo/shared/types";
import { del, get, patch, post } from "./_client";

export const listTeams = () => get<Team[]>("/internal/teams");
export const listMyTeamIds = () => get<TeamMineResponse>("/internal/teams/mine");
export const createTeam = (body: TeamWriteRequest) =>
  post<Team>("/internal/teams", body satisfies TeamWriteRequest);
export const updateTeam = (id: string, body: TeamUpdateRequest) =>
  patch<Team>(`/internal/teams/${id}`, body satisfies TeamUpdateRequest);
export const deleteTeam = (id: string) => del(`/internal/teams/${id}`);
